import React, { Suspense } from 'react';
import { Outlet } from 'react-router';
import logoIcone from '@/assets/img/logo-icone.png?url';
import logoText from '@/assets/img/logo-text-transparent.png?url';

export default function OnboardingLayout() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-[#0a0b0d] flex flex-col">
      <header className="h-14 flex items-center px-6 border-b border-slate-200 dark:border-white/[0.08] bg-white dark:bg-[#0a0b0d]">
        <img src={logoIcone} alt="Eleve.IA" className="size-8" />
        <img src={logoText} alt="Eleve.IA" className="h-4 ml-2 dark:brightness-0 dark:invert" />
      </header>
      <main className="flex-1 flex items-start justify-center py-10 px-4">
        <Suspense fallback={
          <div className="flex items-center justify-center w-full py-24">
            <div className="size-6 border-2 border-slate-300 dark:border-white/10 border-t-indigo-600 dark:border-t-indigo-400 rounded-full animate-spin" />
          </div>
        }>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}
